import React, { Component } from 'react'
import { Checkbox, FormControlLabel, Theme, Typography, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import '../../mylibrary/containers/CustomFilterStyle.css';
import { styles } from '../../course/styling/WithNoContent';
import cx from 'classnames';
import { CONTENT_TYPE_FILTERS, FILTER_CATEGORIES, QUESTION_DEPENDENT_FILTERS_CATEGORY, USER_TYPE } from '../../../constants/comman';
import { showMsg } from '../../course/actions/loaderAlert';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { VALIDATION } from '../constant/content';
import { VARIANT } from '../../common/types/ServerAlertDataV2';
import { getUserType } from '../../../utils';


interface CustomFilterProps extends WithStyles<typeof styles> {
    classes: any,
    handleFilterToggle: Function;
    isFilterOpen: boolean;
    filterData: any[];
    handleFilterSelected: Function;
    fromTestPaper: boolean;
    contentMenuSelected: string;
    showMsg: Function;
    isTeacher: boolean;
}

interface CustomFilterStates {
    currentFilters: any[];
}


class CustomFilter extends Component<CustomFilterProps, CustomFilterStates> {
    studentUser: boolean = getUserType(USER_TYPE.STUDENT);
    constructor(props: CustomFilterProps) {
        super(props);
        this.state = {
            currentFilters: [],
        }
    }

    componentDidUpdate(prevProps: Readonly<CustomFilterProps>, prevState: Readonly<CustomFilterStates>, prevContext: any): void {
        if (prevProps.isFilterOpen !== this.props.isFilterOpen && this.props.isFilterOpen) {
            this.setState({
                currentFilters: JSON.parse(JSON.stringify(this.props.filterData || [])),
            })
        }
    }

    handleFilterSelect = (event: any, filter: any, filterType?: any) => {
        filter.isSelected = event.target.checked;
        if (Object.keys(filterType || {}).length) {
            filterType.isSelected = (filterType.filters || []).some((filter: any) => filter.isSelected);
        } else {
            const allFilterSelected = (filter.filters || []).every((subFilter: any) => subFilter.isSelected);
            if((filter.filters || []).length) {
                filter.filters.forEach((subFilter: any) => {
                    subFilter.isSelected = !allFilterSelected;
                });
                filter.isSelected = !allFilterSelected;
            }
            if(filter.filterValue === CONTENT_TYPE_FILTERS.QUESTION && this.props.contentMenuSelected === VALIDATION.CREATED_BY_ME && this.props.isTeacher && !filter.isSelected && !this.studentUser) {
                this.props.showMsg('Question statistics will only be displayed when the Question Filter is selected. If you choose another filter or a combination of filters, the Question statistics will not be shown.', VARIANT.WARNING);
            }
        }
        const newFilters = [...this.state.currentFilters];
        this.setState({ currentFilters: newFilters });
    }

    resetFilters = () => {
        const { fromTestPaper } = this.props;
        this.state.currentFilters.forEach((filterCategory: any) => {
            (filterCategory.filters || []).forEach((filter: any) => {
                if (VALIDATION.TABS.includes(this.props.contentMenuSelected) && filter.filterValue === CONTENT_TYPE_FILTERS.QUESTION && this.props.isTeacher && !this.studentUser && !fromTestPaper) {
                    filter.isSelected = true;
                    (filter.filters || []).forEach((subFilter: any) => {
                        subFilter.isSelected = true;
                    });
                } else {
                    if (fromTestPaper && filter.disabled) return;
                    filter.isSelected = false;
                    (filter.filters || []).forEach((subFilter: any) => {
                        subFilter.isSelected = false;
                    });
                }
            })
        });
        this.props.handleFilterSelected(this.state.currentFilters);
    }

    onFilterApply = (isQuestionSelected: boolean) => {
        const { currentFilters } = this.state;
        !isQuestionSelected && currentFilters.forEach((filterCategory: any) => {
            if (!QUESTION_DEPENDENT_FILTERS_CATEGORY.includes(filterCategory.filterValue)) return;
            (filterCategory.filters || []).forEach((filter: any) => {
                filter.isSelected = false;
                (filter.filters || []).forEach((subFilter: any) => {
                    subFilter.isSelected = false;
                })
            })
        });
        const newFilters = [...currentFilters];
        this.setState({ currentFilters: newFilters }, () => {
            this.props.handleFilterSelected(newFilters);
        })
    }

    checkQuestionFilterSelected = (): boolean => {
        const {currentFilters} = this.state;
        const contentType = currentFilters.find((filterCategory: any) => filterCategory.filterValue === FILTER_CATEGORIES.CONTENT_TYPE) || {};
        const question = (contentType.filters || []).find((filterType: any) => filterType.filterValue === CONTENT_TYPE_FILTERS.QUESTION) || {};
        return !!question.isSelected;
    }

    render() {
        const { classes, handleFilterToggle, isFilterOpen, contentMenuSelected } = this.props;
        const { currentFilters } = this.state;
        const isQuestionSelected = this.checkQuestionFilterSelected();
        return (

            <div className={cx('filterRight', { ['visibleCustomFilter']: isFilterOpen })}>
                {isFilterOpen && <div className="customFilter">
                    <div className="browseTopicHeadingClose">
                        <Typography variant='h6'>Filters</Typography>
                        <span className="closeRgtBar"><img src="/assets/svg/closeRgtSideBar.svg" alt='Close' onClick={() => handleFilterToggle()} /></span>
                    </div>
                    <div className="filterAccordion">
                        <div className="setHeightFull">
                            {currentFilters && currentFilters.length &&
                                <>
                                    {currentFilters.map((filterCategory: any, index: number) => {
                                        if(!isQuestionSelected && QUESTION_DEPENDENT_FILTERS_CATEGORY.includes(filterCategory.filterValue)) {
                                            return null;
                                        }
                                        return (
                                            <div className="accordion-menu">
                                                <div className="scrollShowPadRgt">
                                                    <ul>
                                                        <li key={index}>                                                             
                                                            <input type="checkbox" className="accordionCheck"/>
                                                            <i className="arrow"></i>
                                                            <h2>{filterCategory.filterTitle}</h2>
                                                            <div className="chkboxList">
                                                                {(filterCategory.filters || []).map((filterType: any) => {
                                                                    if(contentMenuSelected === VALIDATION.VALIDATION_REQUEST && filterCategory.filterValue === FILTER_CATEGORIES.CONTENT_TYPE && filterType.filterValue !== CONTENT_TYPE_FILTERS.QUESTION) return null;
                                                                    return (!(filterType.filters || []).length ?
                                                                        <FormControlLabel
                                                                            control={<Checkbox checked={filterType.isSelected} disabled={filterType.disabled} name={filterType.filterValue} color="primary" onChange={(event: any) => this.handleFilterSelect(event, filterType)} />}
                                                                            label={filterType.filterTitle}
                                                                            value={filterType.filterValue} /> :
                                                                        <div className="scrollShowPadRgt">
                                                                            <ul>
                                                                                <li key={index}>
                                                                                    <input type="checkbox" className="accordionCheck"/>
                                                                                    <i className="arrow"></i>
                                                                                    <FormControlLabel control={<Checkbox name={filterType.filterValue} disabled={filterType.disabled} color="primary" checked={filterType.isSelected} onChange={(event: any) => this.handleFilterSelect(event, filterType)} />}
                                                                                        className={cx("customCheckbox", {'notAll-select':(filterType.filters || []).some((f: any) => f.isSelected) && !(filterType.filters || []).every((f: any) => f.isSelected)})}
                                                                                        label={filterType.filterTitle}
                                                                                        value={filterType.filterValue} />
                                                                                    <div className="chkboxList">
                                                                                        <span className="secondLists">
                                                                                            {(filterType.filters || []).map((filter: any) => <FormControlLabel control={<Checkbox name={filter.filterValue} disabled={filter.disabled || filterType.disabled} color="primary" checked={filter.isSelected} onChange={(event: any) => this.handleFilterSelect(event, filter, filterType)} />}
                                                                                                label={filter.filterTitle}
                                                                                                value={filter.filterValue} />
                                                                                            )}
                                                                                        </span>
                                                                                    </div>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </>
                            }
                        </div>
                    </div>
                    <div className="actionCtaBar">
                        <button className="resetCta" onClick={this.resetFilters}>Reset</button>
                        <button className="applyCta" onClick={() => this.onFilterApply(isQuestionSelected)} >Apply</button>
                    </div>
                </div>}
                <div className="greyOverlay"></div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg,
	},
	dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CustomFilter));
